import { render, staticRenderFns } from "./TabItems.vue?vue&type=template&id=368b7cd6&scoped=true"
import script from "./TabItems.vue?vue&type=script&lang=js"
export * from "./TabItems.vue?vue&type=script&lang=js"
import style0 from "./TabItems.vue?vue&type=style&index=0&id=368b7cd6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368b7cd6",
  null
  
)

export default component.exports